module.exports = __webpack_public_path__ + "media/21.022914c3.mp3";